/* Source: DEV-531 mobile search | 2026-10-18 | per JH request
   What this owns, on HEA B2C (#Search) and HEA B2B (#SearchHEA, #SearchPR):
   1. The results engine. Every keystroke asks Shopify's Predictive Search API
      (/search/suggest, section_id=predictive-search) for relevance-ranked
      products and query suggestions, SKU-aware, 150ms after the last key,
      cancelling any request still in flight. The theme's own handler asked the
      full search page for "<term>*" (slower, ranked by nothing, "1000 RESULTS").
      It was bound by reference to the original input node, so the input is
      replaced with a clone and only this engine answers typing. A second,
      parallel request to the search page (section hea-search-count) supplies
      the "535 RESULTS" number, which the predictive API does not return.
   1b. Round 4 (Boll & Branch pattern): on desktop and tablet the results are
      one row of cards that scrolls sideways; this file drives the progress
      line and the arrows under it.
   2. The phone takeover (640px and below, CSS in custom.css): the panel's
      height follows the visible screen while the keyboard is up
      (--hea-search-vh from visualViewport), the keyboard dismisses when the
      shopper scrolls the results, Clear empties the field, Escape closes.
   3. On B2C, one tap opens the panel AND the keyboard: the field is focused
      inside the tap itself (iOS only opens a keyboard for a focus made during a
      user gesture; the theme focused after the open animation, so the first tap
      only opened the panel). B2B's custom.js already focuses inside the tap. */
(function () {
  'use strict';
  if (window.__heaSearchInit) return;
  window.__heaSearchInit = true;

  var PHONE = window.matchMedia('(max-width: 640px)');
  var searchUrl = (window.routes && window.routes.searchUrl) || '/search';
  var panels = Array.prototype.slice.call(document.querySelectorAll('#SearchHEA, #SearchPR'));
  if (!panels.length) {
    var single = document.getElementById('Search');
    if (single) panels.push(single);
  }
  panels.forEach(setup);

  function setup(panel) {
    var form = panel.querySelector('form[role="search"]');
    var oldInput = panel.querySelector('input[name="q"]');
    var inner = panel.querySelector('.Search__Inner');
    var results = panel.querySelector('.Search__Results:not(.Search__Results--suggestions)');
    if (!form || !oldInput || !inner || !results) return;

    /* B2C only: the theme's handler holds the original node, so swap it out.
       On B2B custom.js holds the node for its in-tap focus, and nothing else
       listens to it, so it stays. */
    var input = oldInput;
    if (panel.id === 'Search') {
      input = oldInput.cloneNode(true);
      oldInput.parentNode.replaceChild(input, oldInput);
    }
    var clearBtn = panel.querySelector('[data-action="clear-search"]');
    var closeBtn = panel.querySelector('[data-action="close-search"]');
    var timer = null;
    var controller = null;
    var countController = null;
    var lastQuery = '';
    var counts = {};

    function isOpen() { return panel.getAttribute('aria-hidden') === 'false'; }
    function setLoading(on) { panel.classList.toggle('Search--loading', !!on); }
    function abort() {
      if (controller) { controller.abort(); controller = null; }
      if (countController) { countController.abort(); countController = null; }
    }
    function applyCount(query) {
      var slot = results.querySelector('[data-search-count-number]');
      if (!slot || results.getAttribute('data-query') !== query) return;
      var n = counts[query];
      slot.textContent = (typeof n === 'number') ? n.toLocaleString() + ' ' : '';
    }
    function showResults(html, query) {
      results.innerHTML = html;
      results.setAttribute('data-query', query);
      results.setAttribute('aria-hidden', 'false');
      inner.scrollTop = 0;
      applyCount(query);
      initCarousel(results.querySelector('[data-search-carousel]'));
    }
    function clearResults() {
      results.innerHTML = '';
      results.removeAttribute('data-query');
      results.setAttribute('aria-hidden', 'true');
    }

    /* "535 RESULTS": the search page renders a one-number section. */
    function requestCount(query) {
      if (typeof counts[query] === 'number') return;
      countController = new AbortController();
      var signal = countController.signal;
      var url = searchUrl + '?q=' + encodeURIComponent(query) +
        '&type=product&options[prefix]=last&section_id=hea-search-count';
      fetch(url, { credentials: 'same-origin', signal: signal })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (signal.aborted) return;
          var match = /<div[^>]*>\s*(\d+)\s*<\/div>/.exec(html);
          if (!match) return;
          counts[query] = parseInt(match[1], 10);
          applyCount(query);
        })
        .catch(function () {});
    }

    /* The sideways row of cards (desktop and tablet): progress line + arrows. */
    function initCarousel(carousel) {
      if (!carousel) return;
      var track = carousel.querySelector('[data-search-track]');
      var thumb = carousel.querySelector('[data-search-thumb]');
      var prev = carousel.querySelector('[data-search-prev]');
      var next = carousel.querySelector('[data-search-next]');
      if (!track || !thumb) return;
      var ticking = false;
      function paint() {
        ticking = false;
        var total = track.scrollWidth;
        var visible = track.clientWidth;
        if (total <= visible + 1) {
          carousel.classList.add('Search__Carousel--static');
          return;
        }
        carousel.classList.remove('Search__Carousel--static');
        var left = track.scrollLeft;
        thumb.style.width = Math.max(8, (visible / total) * 100) + '%';
        thumb.style.left = ((left / total) * 100) + '%';
        if (prev) prev.disabled = left <= 1;
        if (next) next.disabled = left + visible >= total - 1;
      }
      function schedule() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(paint);
      }
      track.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule);
      function step(direction) {
        var card = track.querySelector('.Search__Card');
        var gap = card ? parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0 : 0;
        var cardWidth = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        var perView = Math.max(1, Math.floor(track.clientWidth / cardWidth));
        track.scrollBy({ left: direction * perView * cardWidth, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });
      if (track.querySelectorAll('img').length) {
        track.querySelectorAll('img').forEach(function (img) { img.addEventListener('load', schedule, { once: true }); });
      }
      paint();
    }

    function request(query) {
      abort();
      controller = new AbortController();
      var signal = controller.signal;
      var url = searchUrl + '/suggest?q=' + encodeURIComponent(query) +
        '&resources[type]=product,query&resources[limit]=10&resources[limit_scope]=each' +
        '&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku' +
        '&section_id=predictive-search';
      setLoading(true);
      requestCount(query);
      fetch(url, { credentials: 'same-origin', signal: signal })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          if (signal.aborted || input.value.trim() !== query) return;
          showResults(html, query);
          setLoading(false);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          setLoading(false);
        });
    }

    function onInput() {
      var query = input.value.trim();
      if (clearBtn) clearBtn.hidden = query === '';
      clearTimeout(timer);
      if (query === '') {
        abort();
        setLoading(false);
        clearResults();
        lastQuery = '';
        return;
      }
      if (query === lastQuery) return;
      timer = setTimeout(function () {
        lastQuery = query;
        request(query);
      }, 150);
    }

    input.addEventListener('input', onInput);

    if (clearBtn) {
      clearBtn.addEventListener('click', function (event) {
        event.preventDefault();
        input.value = '';
        onInput();
        input.focus();
      });
    }

    panel.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && closeBtn && isOpen()) {
        event.preventDefault();
        closeBtn.click();
      }
    });

    /* Phone takeover: keyboard-aware height, keyboard away on scroll. */
    function syncViewport() {
      if (!PHONE.matches || !isOpen()) {
        panel.style.removeProperty('--hea-search-vh');
        return;
      }
      var vv = window.visualViewport;
      if (vv && vv.height) panel.style.setProperty('--hea-search-vh', Math.round(vv.height) + 'px');
    }
    if (window.visualViewport) window.visualViewport.addEventListener('resize', syncViewport);
    window.addEventListener('orientationchange', syncViewport);
    new MutationObserver(function () {
      syncViewport();
      if (!isOpen()) {
        clearTimeout(timer);
        abort();
        setLoading(false);
      }
    }).observe(panel, { attributes: true, attributeFilter: ['aria-hidden'] });

    inner.addEventListener('touchmove', function () {
      if (PHONE.matches && document.activeElement === input) input.blur();
    }, { passive: true });

    /* B2C only: open and focus inside the tap so the keyboard comes up at once. */
    if (panel.id === 'Search') {
      document.addEventListener('click', function (event) {
        var toggle = event.target.closest ? event.target.closest('[data-action="toggle-search"]') : null;
        if (!toggle || !PHONE.matches || isOpen()) return;
        panel.setAttribute('aria-hidden', 'false');
        void panel.offsetHeight;
        try { input.focus({ preventScroll: true }); } catch (error) { input.focus(); }
      }, true);
    }
  }
})();
